import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Typography, Button, Box, Paper } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import {
    APPLICATION_SLUGS,
    APPLICATION_DISPLAY_NAMES,
    ApplicationSlug,
} from '../../../constants/applications'
import { Routes } from '../../../navigation/config/routes'
import { ReactComponent as EZTurnIcon } from '../../../assets/icons/ez-turn.svg'
import { ReactComponent as EZFolioLogo } from '../../../assets/icons/ez-folio.svg'
import { ReactComponent as EZManageLogo } from '../../../assets/icons/ez-manage.svg'
import { ReactComponent as GardLogo } from '../../../assets/icons/GARD.svg'
import { ReactComponent as EZVendorLogo } from '../../../assets/EZVendor.svg'

const APPLICATION_LOGOS: Record<
    ApplicationSlug,
    React.ComponentType<
        React.SVGAttributes<SVGElement> & { style?: React.CSSProperties }
    >
> = {
    [APPLICATION_SLUGS.EZTURN]: EZTurnIcon,
    [APPLICATION_SLUGS.EZFOLIO]: EZFolioLogo,
    [APPLICATION_SLUGS.EZMANAGE]: EZManageLogo,
    [APPLICATION_SLUGS.GARD]: GardLogo,
    [APPLICATION_SLUGS.EZTENANT]: EZTurnIcon,
    [APPLICATION_SLUGS.EZVENDOR]: EZVendorLogo,
}

export const ApplicationAccessDenied: React.FC = () => {
    const history = useHistory()
    const location = useLocation<{ applicationSlug?: string }>()
    const applicationSlug = (
        location.state?.applicationSlug ?? ''
    ).toLowerCase()

    const displayName =
        applicationSlug && applicationSlug in APPLICATION_DISPLAY_NAMES
            ? APPLICATION_DISPLAY_NAMES[applicationSlug as ApplicationSlug]
            : 'this application'
    const LogoComponent =
        applicationSlug && applicationSlug in APPLICATION_LOGOS
            ? APPLICATION_LOGOS[applicationSlug as ApplicationSlug]
            : null

    const handleGoBack = () => {
        if (history.length > 1) {
            history.go(-1)
        } else {
            history.push(Routes.public.login)
        }
    }

    return (
        <Paper
            elevation={2}
            style={{
                padding: 48,
                width: '100%',
                maxWidth: 440,
                textAlign: 'center',
                borderRadius: 12,
                boxSizing: 'border-box',
            }}
        >
            {LogoComponent && (
                <Box
                    style={{
                        marginBottom: 24,
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    {/* Logos are white (for dark AppSelector bar) — show on dark tile on light page */}
                    <Box
                        style={{
                            width: 88,
                            height: 88,
                            borderRadius: 12,
                            backgroundColor: '#2f2e41',
                            color: '#fff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <LogoComponent
                            style={{ width: 56, height: 56, display: 'block' }}
                        />
                    </Box>
                </Box>
            )}
            <Typography variant="h5" component="h1" gutterBottom>
                You don&apos;t have access to {displayName}
            </Typography>
            <Typography
                variant="body1"
                color="textSecondary"
                style={{ marginBottom: 32 }}
            >
                Your company has not been granted access to this application.
                Please contact your administrator if you believe this is an
                error.
            </Typography>
            <Button
                variant="contained"
                color="primary"
                startIcon={<ArrowBackIcon />}
                onClick={handleGoBack}
            >
                Go back
            </Button>
        </Paper>
    )
}
